import {
    Check,
    ChevronDown,
    ChevronUp,
    Download,
    FileText,
    Filter,
    FolderOpen,
    Heart,
    LogOut,
    MailOpen,
    Paperclip,
    Search,
    ThumbsDown,
    ThumbsUp,
    Trash2,
    Upload,
    X,
} from "lucide-react";
import { fromLucide } from "./fromLucide";

/** heroicons 24/outline names → lucide (stroke 1.5, like heroicons outline). */
const outline = { strokeWidth: 1.5 };

export const ArrowDownTrayIcon = fromLucide(Download, outline, "ArrowDownTrayIcon");
export const ArrowRightOnRectangleIcon = fromLucide(LogOut, outline, "ArrowRightOnRectangleIcon");
export const ArrowUpTrayIcon = fromLucide(Upload, outline, "ArrowUpTrayIcon");
export const CheckIcon = fromLucide(Check, outline, "CheckIcon");
export const ChevronDownIcon = fromLucide(ChevronDown, outline, "ChevronDownIcon");
export const ChevronUpIcon = fromLucide(ChevronUp, outline, "ChevronUpIcon");
export const DocumentTextIcon = fromLucide(FileText, outline, "DocumentTextIcon");
export const EnvelopeOpenIcon = fromLucide(MailOpen, outline, "EnvelopeOpenIcon");
export const FolderOpenIcon = fromLucide(FolderOpen, outline, "FolderOpenIcon");
export const FunnelIcon = fromLucide(Filter, outline, "FunnelIcon");
export const HandThumbDownIcon = fromLucide(ThumbsDown, outline, "HandThumbDownIcon");
export const HandThumbUpIcon = fromLucide(ThumbsUp, outline, "HandThumbUpIcon");
export const HeartIcon = fromLucide(Heart, outline, "HeartIcon");
export const MagnifyingGlassIcon = fromLucide(Search, outline, "MagnifyingGlassIcon");
export const PaperClipIcon = fromLucide(Paperclip, outline, "PaperClipIcon");
export const TrashIcon = fromLucide(Trash2, outline, "TrashIcon");
export const XMarkIcon = fromLucide(X, outline, "XMarkIcon");
